export default __webpack_public_path__ + "static/media/banner_right_circle.c90d36ad.svg";